import { useState } from 'react';
import { Switch } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { NationalModifiersDetails } from '@/types/nationalModifiers.types';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';

export const SwitchCell = ({ row, table, column }: CellContext<NationalModifiersDetails, unknown>) => {
  const { original } = row;
  const { isLock, ...rest } = original;
  const { updateData } = table.options.meta as CustomTableMeta<NationalModifiersDetails>;
  const [checked, setChecked] = useState(isLock);

  const handleClick = () => {
    const saveIsLock = !checked;
    setChecked(saveIsLock);
    updateData(row.index, column.id, `${saveIsLock}`);
  };

  return <Switch color="error" title="switch" checked={checked} onClick={() => handleClick()} {...rest} />;
};
